import { Phone } from "lucide-react";
import { WhatsAppIcon } from "./Logo";
import { PHONE_TEL, WHATSAPP } from "./data";

export const MobileBar = () => (
  <div data-testid="mobile-fixed-bar" className="fixed inset-x-0 bottom-0 z-50 border-t border-black/5 bg-white/90 p-3 backdrop-blur-xl md:hidden">
    <div className="grid grid-cols-[1.4fr_1fr] gap-2.5">
      <a href={PHONE_TEL} data-testid="mobile-bar-call-button" className="flex h-12 items-center justify-center gap-2 rounded-xl bg-[var(--cta)] text-base font-bold text-white active:scale-[0.98]">
        <Phone className="h-5 w-5" /> Hívás Most
      </a>
      <a href={WHATSAPP} target="_blank" rel="noopener noreferrer" data-testid="mobile-bar-whatsapp-button" className="flex h-12 items-center justify-center gap-2 rounded-xl bg-[#1E8E4F] text-base font-bold text-white active:scale-[0.98]">
        <WhatsAppIcon className="h-5 w-5" /> WhatsApp
      </a>
    </div>
  </div>
);
